import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import mainPhoto from '../assets/images/Subject 2.webp';
import collagePhoto1 from '../assets/images/Subject.webp';
import collagePhoto2 from '../assets/images/IMG_4649.webp';
import '../styles/Hero.css';

gsap.registerPlugin(ScrollTrigger);

const Hero = () => {
  const heroRef = useRef(null);
  const nameRef = useRef(null);
  const taglineRef = useRef(null);
  const buttonRef = useRef(null);
  const bgRef = useRef(null);
  const photosRef = useRef(null);

  useEffect(() => {
    // Initial entrance animation
    const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

    tl.from(photosRef.current.children, {
      scale: 0.9,
      y: 50,
      duration: 1,
      stagger: 0.2
    })
      .from(nameRef.current, {
        y: 100,
        scale: 0.95,
        duration: 1
      }, '-=0.6')
      .from(taglineRef.current, {
        y: 50,
        duration: 0.8
      }, '-=0.5')
      .from(buttonRef.current, {
        y: 30,
        scale: 0.9,
        duration: 0.6
      }, '-=0.4');

    // Parallax effect on mouse move
    const handleMouseMove = (e) => {
      const { clientX, clientY } = e;
      const x = (clientX / window.innerWidth - 0.5) * 20;
      const y = (clientY / window.innerHeight - 0.5) * 20;

      gsap.to(bgRef.current, {
        x: x,
        y: y,
        duration: 1,
        ease: 'power2.out'
      });
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  const scrollToNext = () => {
    const aboutSection = document.getElementById('about');
    aboutSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section ref={heroRef} className="hero" id="hero">
      <div ref={bgRef} className="hero-background">
        <div ref={photosRef} className="photo-collage">
          <div className="main-photo">
            <img src={mainPhoto} alt="Main" />
            <div className="photo-overlay"></div>
          </div>
          <div className="collage-photos">
            <div className="collage-item collage-1">
              <img src={collagePhoto1} alt="Collage 1" />
              <div className="photo-overlay"></div>
            </div>
            <div className="collage-item collage-2">
              <img src={collagePhoto2} alt="Collage 2" />
              <div className="photo-overlay"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="hero-content">
        <h1 ref={nameRef} className="hero-name">
          Momen Medhat
        </h1>
        <p ref={taglineRef} className="hero-tagline">
          Senior Python Developer
        </p>
        <button ref={buttonRef} className="hero-button" onClick={scrollToNext}>
          Explore My Work
          <span className="arrow">↓</span>
        </button>
      </div>
    </section>
  );
};

export default Hero;
